import { Spinner, ProgressBar, OPTS } from "../../shared/ui";

// ── Quiz Host Screen ──────────────────────────────────────────────────────────
// Props:
//   question   : string | null
//   options    : string[]
//   answered   : string[]   — list of player names who answered
//   players    : object[]   — full player list
//   result     : { correct: number, scores: object } | null
//   tv         : bool

export default function QuizHost({ question, options, answered, players, result, tv }) {
  if (!question) return <Spinner color="#FF00FF" tv={tv} />;

  return (
    <div className="w-full animate-slide-up">
      <div className="text-center mb-6">
        <div style={{
          display: "inline-block", background: "#1e0845", border: "3px solid #000",
          borderRadius: "1.5rem", boxShadow: "5px 5px 0 #000",
          padding: tv ? "1.75rem 2.75rem" : "0.9rem 1.25rem", maxWidth: "93%",
        }}>
          <h2 className="font-heading text-white" style={{ fontSize: tv ? "3rem" : "1.5rem", lineHeight: 1.3 }}>
            {question}
          </h2>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4 mb-5">
        {options.map((opt, i) => (
          <div key={i} style={{
            background: OPTS.colors[i], border: "3px solid #000", borderRadius: "1.25rem",
            boxShadow: result && result.correct === i ? "7px 7px 0 #000" : "5px 5px 0 #000",
            opacity: result && result.correct !== i ? 0.45 : 1,
            transform: result && result.correct === i ? "scale(1.04)" : "scale(1)",
            transition: "all 0.3s",
            padding: tv ? "2rem 1.25rem" : "1.25rem 0.9rem",
            textAlign: "center",
          }}>
            <div className="font-display" style={{ fontSize: tv ? "3.5rem" : "1.75rem", color: "#000", marginBottom: "0.3rem" }}>
              {OPTS.labels[i]}
            </div>
            <div className="font-heading font-bold" style={{ fontSize: tv ? "1.9rem" : "0.95rem", color: "#000", lineHeight: 1.2 }}>
              {opt}
            </div>
          </div>
        ))}
      </div>

      <div className="text-center">
        {!result ? (
          <>
            <div className="font-heading text-[#aaa] mb-2" style={{ fontSize: tv ? "1.4rem" : "0.9rem" }}>
              Ответили: {answered.length}/{players.length}
            </div>
            <ProgressBar value={answered.length} max={players.length} color="#3DFF3D" tv={tv} />
          </>
        ) : (
          <div className="animate-bounce-in font-heading" style={{
            fontSize: tv ? "2.25rem" : "1.35rem", color: "#3DFF3D", textShadow: "2px 2px 0 #000",
          }}>
            ✅ Правильный: {OPTS.labels[result.correct]}
          </div>
        )}
      </div>
    </div>
  );
}
